import { isAxiosError } from 'axios';

// Backend validation / business messages come in `message`; fall back to a Spanish text
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (isAxiosError<{ message?: string }>(error)) {
    return error.response?.data?.message ?? fallback;
  }
  return fallback;
};

export const getApiErrorStatus = (error: unknown): number | undefined =>
  isAxiosError(error) ? error.response?.status : undefined;

// Requests with responseType 'blob' get JSON error bodies as a Blob; parse them to read `message`
export const getBlobApiErrorMessage = async (error: unknown, fallback: string): Promise<string> => {
  if (!isAxiosError(error) || !(error.response?.data instanceof Blob)) {
    return getApiErrorMessage(error, fallback);
  }
  try {
    const body = JSON.parse(await error.response.data.text()) as { message?: string };
    return body.message ?? fallback;
  } catch {
    return fallback;
  }
};
